import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';


// Import translations
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: {
          translation: enTranslations
        },
        ar: {
          translation: arTranslations
        }
      },
      fallbackLng: 'en',
      debug: true,
      interpolation: {
        escapeValue: false
      },
      detection: {
        order: ['querystring', 'cookie'],
        lookupQuerystring: 'lang', 
        caches: ['cookie'],
      },
      supportedLngs: ['en', 'ar']
    });

  // Set initial direction
  document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = i18n.language;

  // Handle RTL direction
  i18n.on('languageChanged', (lng: string) => {
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  });
}

export default i18n;
